import { Input } from '@/components/ui/Input'
import { Button } from '@/components/ui/Button'
import './formation-header.css'

interface FormationHeaderProps {
	name: string
	onNameChange: (name: string) => void
	mirroredName?: string
	onMirroredNameChange?: (name: string) => void
	autoMirror: boolean
	onBackToPlaybook: () => void
}

export function FormationHeader({
	name,
	onNameChange,
	mirroredName,
	onMirroredNameChange,
	autoMirror,
	onBackToPlaybook,
}: FormationHeaderProps) {
	return (
		<div className="formation-header">
			<div className="formation-header__content">
				<div className="formation-header__inputs">
					<Input
						className="formation-header__name-input"
						placeholder="Formation name..."
						value={name}
						onChange={(e) => onNameChange(e.target.value)}
						maxLength={100}
					/>

					{autoMirror && (
						<Input
							className="formation-header__name-input formation-header__name-input--mirrored"
							placeholder="Mirrored formation name..."
							value={mirroredName ?? ''}
							onChange={(e) => onMirroredNameChange?.(e.target.value)}
							maxLength={100}
						/>
					)}
				</div>

				<div className="formation-header__button-area">
					<Button variant="action" className="formation-header__button" onClick={onBackToPlaybook}>
						Back to Playbook
					</Button>
				</div>
			</div>
		</div>
	)
}
